(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calabasa-closer-look"] && !Shopify.designMode) return;
  try {
    
/* Section 2 — A closer look. Pinned cards: copy lifts away, the component stays hovering, the next card takes over.
   Open layout: each component fades as the next arrives, then the finale assembles the bottle. */
(() => {
  if (customElements.get('calabasa-closer-look')) return;
  const fallbackLoad = () => {
    const load = (name, url) => new Promise((res, rej) => {
      if (window[name]) return res(window[name]);
      const s = document.createElement('script'); s.src = url; s.async = true;
      s.onload = () => window[name] ? res(window[name]) : rej(); s.onerror = rej;
      document.head.append(s);
    });
    return load('gsap', 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js')
      .then(() => load('ScrollTrigger', 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js'))
      .then(() => { window.gsap.registerPlugin(window.ScrollTrigger); return window.gsap; });
  };
  const libraries = () => (window.CalabasaHome && window.CalabasaHome.ensureAnimationLibraries)
    ? window.CalabasaHome.ensureAnimationLibraries() : fallbackLoad();
  const px = el => parseFloat(getComputedStyle(el).top) || 0;

  class CalabasaCloserLook extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.abort = new AbortController();
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      motion.addEventListener('change', () => { if (motion.matches) this.teardown(); }, { signal: this.abort.signal });
      if (motion.matches || (window.Shopify && window.Shopify.designMode)) return;
      libraries().then(gsap => {
        if (!this.isConnected || motion.matches || this.abort.signal.aborted) return;
        const ST = window.ScrollTrigger;
        const open = this.classList.contains('cl--open');
        const dark = parseFloat(this.dataset.clDark) || 0;
        const cards = [...this.querySelectorAll('[data-cl-card]')];
        const marks = [...this.querySelectorAll('[data-cl-sentinel]')];
        // Open layout pins every card in the same place; the original steps each one down.
        cards.forEach((c, i) => c.style.setProperty('--i', open ? 0 : i));
        this.classList.add('is-enhanced');
        this.ctx = gsap.context(() => {
          cards.forEach((card, i) => {
            const isFinale = card.hasAttribute('data-cl-finale');
            if (!isFinale) {
              const text = card.querySelector('[data-cl-text]');
              // Component photo fades in the same way as the big CALABASA wordmark: rises 10px over 1.5s, once.
              const img = card.querySelector('.cl-img');
              if (img) gsap.fromTo(img, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 1.5, ease: 'power1.inOut', scrollTrigger: { trigger: card, start: 'top 85%', once: true } });
              // Phase 1: once the card pins, its copy lifts away and collapses, so the component takes the whole card.
              gsap.timeline({ scrollTrigger: {
                // Hold the copy for a while after the card settles, then lift it away.
                trigger: marks[i], start: () => `top ${px(card) - innerHeight * 0.45}`, end: () => `+=${innerHeight * 0.5}`,
                scrub: 0.6, invalidateOnRefresh: true,
                // Back above the pin: hand the row its natural size again, so nothing can stay clipped.
                onLeaveBack: () => gsap.set(text, { clearProps: 'height,paddingTop,paddingBottom' }) } })
                .to(text, { opacity: 0, y: -14, duration: 0.45, ease: 'none' }, 0)
          // The copy only fades: its row keeps its height, so the component never grows as you scroll.
          ;
            }
            // Phase 2: as the next card slides up, this one gives way.
            const next = cards[i + 1];
            if (next) {
              const tl = gsap.timeline({ scrollTrigger: {
                trigger: marks[i + 1], start: 'top bottom', end: () => `top ${px(next)}`,
                scrub: 0.6, invalidateOnRefresh: true } });
              if (open) {
                // No card behind it any more, so fade it out before the next component lands.
                // Before the finale it goes sooner, leaving a clear beat before the bottle is assembled.
                const beforeFinale = next.hasAttribute('data-cl-finale');
                tl.to(card, { opacity: 0, duration: beforeFinale ? 0.35 : 0.6, ease: 'none' }, 0).to({}, { duration: beforeFinale ? 0.65 : 0.4 });
              } else {
                const dim = card.querySelector('[data-cl-dim]');
                tl.to(dim, { opacity: 0.5, ease: 'none' }, 0);
              }
            }
          });

          // Finale: dim the background and fade in the finished bottle photo.
          const fin = this.querySelector('[data-cl-finale]');
          if (fin) {
            const mark = marks[cards.indexOf(fin)];
            const shade = this.querySelector('[data-cl-shade]');
            const photo = fin.querySelector('[data-cl-photo]');
            gsap.fromTo(shade, { opacity: 0 }, { opacity: dark, ease: 'none', scrollTrigger: {
              trigger: mark, start: 'top 90%', end: () => `top ${px(fin)}`, scrub: true, invalidateOnRefresh: true } });
            // The finished bottle fades in as its screen settles, then the heading follows.
            const tl = gsap.timeline({ scrollTrigger: {
              trigger: mark, start: () => `top ${px(fin) + innerHeight * 0.4}`, end: () => `+=${innerHeight * 0.7}`,
              scrub: 0.8, invalidateOnRefresh: true } });
            if (photo) tl.fromTo(photo, { opacity: 0, y: 24 }, { opacity: 1, y: 0, duration: 1, ease: 'power2.out' }, 0);
            tl.fromTo(fin.querySelector('[data-cl-finale-text]'), { opacity: 0, y: 16 }, { opacity: 1, y: 0, duration: 0.5 }, 0.8)
              .to({}, { duration: 0.3 });
            // Lift the dimming again as the section ends, so the next textured section follows on cleanly.
            gsap.fromTo(shade, { opacity: dark }, { opacity: 0, ease: 'none', immediateRender: false, scrollTrigger: {
              trigger: this, start: 'bottom 170%', end: 'bottom 105%', scrub: true } });
          }
        }, this);
        const refresh = () => { if (!this.abort.signal.aborted) ST.refresh(); };
        this.querySelectorAll('img').forEach(img => { if (!img.complete) img.addEventListener('load', refresh, { once: true, signal: this.abort.signal }); });
        document.addEventListener('calabasa:intro-complete', refresh, { signal: this.abort.signal });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
        requestAnimationFrame(refresh);
      }).catch(() => this.teardown());
    }
    teardown() {
      if (this.ctx) { this.ctx.revert(); this.ctx = null; }
      this.classList.remove('is-enhanced');
    }
    disconnectedCallback() { this.abort && this.abort.abort(); this.teardown(); this.ready = false; }
  }
  customElements.define('calabasa-closer-look', CalabasaCloserLook);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calabasa-cocktails"] && !Shopify.designMode) return;
  try {
    
/* Section 4 — Signature cocktails: pinned sideways deck driven by scroll. */
(() => {
  if (customElements.get('calabasa-cocktails')) return;
  const fallbackLoad = () => {
    const load = (name, url) => new Promise((res, rej) => {
      if (window[name]) return res(window[name]);
      const s = document.createElement('script'); s.src = url; s.async = true;
      s.onload = () => window[name] ? res(window[name]) : rej(); s.onerror = rej; document.head.append(s);
    });
    return load('gsap', 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js')
      .then(() => load('ScrollTrigger', 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js'))
      .then(() => { window.gsap.registerPlugin(window.ScrollTrigger); return window.gsap; });
  };
  const libraries = () => (window.CalabasaHome && window.CalabasaHome.ensureAnimationLibraries)
    ? window.CalabasaHome.ensureAnimationLibraries() : fallbackLoad();

  // Deck timing, in "cards" of scroll. LEAD: the first card holds in front before the next one moves.
  // DIM_DELAY / DIM_LENGTH: a card only starts to darken once the next card is part-way across it.
  const LEAD = 0.35, DIM_DELAY = 0.5, DIM_LENGTH = 0.5;

  // Scroll to a position, driven frame by frame so nothing on the page can cut it short.
  const glideTo = (y, instant) => {
    if (instant) { window.scrollTo(0, y); return; }
    const y0 = window.scrollY, t0 = performance.now(), dur = Math.min(900, 300 + Math.abs(y - y0) * 0.4);
    const ease = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = now => {
      const p = Math.min(1, (now - t0) / dur);
      window.scrollTo(0, y0 + (y - y0) * ease(p));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  class CalabasaCocktails extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.abort = new AbortController();
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      motion.addEventListener('change', () => { if (motion.matches) this.teardown(); }, { signal: this.abort.signal });
      // Recipe dialogs: work with or without motion, and in the theme editor.
      this.querySelectorAll('[data-cc-open]').forEach(btn => {
        const dlg = this.querySelector('#' + btn.dataset.ccOpen);
        if (!dlg) return;
        btn.addEventListener('click', () => {
          if (typeof dlg.showModal === 'function') { dlg.showModal(); document.documentElement.classList.add('cc-lock'); }
          else dlg.setAttribute('open', '');
        }, { signal: this.abort.signal });
        dlg.addEventListener('close', () => { document.documentElement.classList.remove('cc-lock'); btn.focus({ preventScroll: true }); }, { signal: this.abort.signal });
        dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); }, { signal: this.abort.signal });
        dlg.querySelectorAll('[data-cc-close]').forEach(c => c.addEventListener('click', () => dlg.close(), { signal: this.abort.signal }));
      });

      const cards = [...this.querySelectorAll('[data-cc-card]')];
      const dims = cards.map(c => c.querySelector('[data-cc-dim]'));
      const names = cards.map(c => (c.querySelector('.cc-name') || c).textContent.trim().replace(/\s+/g, ' '));
      this.current = 0;

      // Click (or Enter/Space on) any card that is not in front to bring it into focus.
      // Buttons inside a card behind are held back so the first click only brings the card forward.
      const focusCard = i => {
        if (this.st) {
          const st = this.st, total = this.total;
          const at = i === 0 ? 0 : LEAD + i;
          const y = st.start + (at / total) * (st.end - st.start) + 2;
          glideTo(y, motion.matches);
        } else {
          const track = this.querySelector('.cc-track');
          const c = cards[i];
          if (track && c) track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.clientWidth) / 2, behavior: motion.matches ? 'auto' : 'smooth' });
          this.current = i; this.markCards();
        }
      };
      cards.forEach((card, i) => {
        card.addEventListener('click', e => {
          if (i === this.current) return;
          e.preventDefault(); e.stopPropagation();
          focusCard(i);
        }, { capture: true, signal: this.abort.signal });
        card.addEventListener('keydown', e => {
          if (i === this.current || e.target !== card) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); focusCard(i); }
        }, { signal: this.abort.signal });
      });
      // Arrows and dashes under the deck: step or jump between cocktails, in the pinned deck and the swipeable row.
      const hudDots = [...this.querySelectorAll('[data-cc-dot]')];
      const hudCount = this.querySelector('[data-cc-count]');
      const prevBtn = this.querySelector('[data-cc-prev]'), nextBtn = this.querySelector('[data-cc-next]');
      const updateHud = () => {
        const i = this.current || 0;
        hudDots.forEach((d, k) => { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (hudCount) hudCount.textContent = String(i + 1).padStart(2, '0');
        if (prevBtn) prevBtn.disabled = i <= 0;
        if (nextBtn) nextBtn.disabled = i >= cards.length - 1;
      };
      hudDots.forEach((d, k) => d.addEventListener('click', () => focusCard(k), { signal: this.abort.signal }));
      if (prevBtn) prevBtn.addEventListener('click', () => focusCard(Math.max(0, (this.current || 0) - 1)), { signal: this.abort.signal });
      if (nextBtn) nextBtn.addEventListener('click', () => focusCard(Math.min(cards.length - 1, (this.current || 0) + 1)), { signal: this.abort.signal });
      this.markCards = () => {
        cards.forEach((c, k) => {
          const behind = k !== this.current;
          c.classList.toggle('is-behind', behind);
          if (behind) { c.tabIndex = 0; c.setAttribute('aria-label', 'Show ' + names[k]); }
          else { c.removeAttribute('tabindex'); c.removeAttribute('aria-label'); }
          c.querySelectorAll('a,button').forEach(el => { el.tabIndex = behind ? -1 : 0; });
        });
        updateHud();
      };
      // In the swipeable row (phones, no motion, theme editor), track which card is centred.
      const track = this.querySelector('.cc-track');
      if (track && 'IntersectionObserver' in window) {
        this.rowIO = new IntersectionObserver(es => es.forEach(e => {
          if (e.isIntersecting && !this.st) { this.current = cards.indexOf(e.target); this.markCards(); }
        }), { root: track, threshold: 0.6 });
        cards.forEach(c => this.rowIO.observe(c));
      }
      this.markCards();

      if (cards.length < 2 || motion.matches || matchMedia('(max-width: 799px)').matches || (window.Shopify && window.Shopify.designMode)) return;
      libraries().then(gsap => {
        if (!this.isConnected || motion.matches || this.abort.signal.aborted) return;
        const ST = window.ScrollTrigger;
        const deck = this.querySelector('[data-cc-deck]');
        const count = this.querySelector('[data-cc-count]');
        const dots = [...this.querySelectorAll('[data-cc-dot]')];
        const n = cards.length, step = 85, hold = 35; // svh of scroll per card change, and a pause at the end
        this.total = LEAD + (n - 1) + hold / step;   // timeline length in "cards"
        deck.style.height = `calc(100svh + ${this.total * step}svh)`;
        this.classList.add('is-enhanced');
        if (this.rowIO) { this.rowIO.disconnect(); this.rowIO = null; }
        const setCurrent = i => {
          if (i === this.current && this.marked) return;
          this.current = i; this.marked = true;
          cards.forEach((c, k) => c.setAttribute('aria-hidden', k === i ? 'false' : 'true'));
          if (count) count.textContent = String(i + 1).padStart(2, '0');
          dots.forEach((d, k) => { d.classList.toggle('is-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
          this.markCards();
        };
        // Overlay on each card, worked out from the deck's current time, so it can't drift or stick.
        // A card darkens one step for each card that has moved over it (max 62%).
        const paintDims = t => {
          dims.forEach((d, j) => {
            if (!d) return;
            let depth = 0;
            for (let i = j + 1; i < n; i++) {
              const begins = LEAD + (i - 1) + DIM_DELAY;
              depth += Math.min(1, Math.max(0, (t - begins) / DIM_LENGTH));
            }
            d.style.opacity = Math.min(0.62, depth * 0.34).toFixed(3);
          });
        };
        this.ctx = gsap.context(() => {
          cards.forEach((c, k) => gsap.set(c, { xPercent: k === 0 ? 0 : 118, scale: 1, x: 0, zIndex: k + 1, transformOrigin: '0% 50%' }));
          const tl = gsap.timeline({ defaults: { ease: 'none' }, scrollTrigger: {
            trigger: deck, start: 'top top', end: 'bottom bottom',
            scrub: 0.7, invalidateOnRefresh: true,
            onUpdate: self => {
              const t = self.progress * this.total;
              setCurrent(Math.min(n - 1, Math.max(0, Math.round(t - LEAD))));
            } } });
          tl.eventCallback('onUpdate', () => paintDims(tl.time()));
          this.st = tl.scrollTrigger;
          for (let i = 1; i < n; i++) {
            const at = LEAD + i - 1;
            tl.fromTo(cards[i], { xPercent: 118 }, { xPercent: 0, ease: 'power1.inOut', duration: 1, immediateRender: false }, at);
            for (let j = 0; j < i; j++) {
              const depth = i - j;
              const prev = depth - 1;
              tl.fromTo(cards[j], { scale: 1 - prev * 0.05, x: -prev * 44 }, { scale: 1 - depth * 0.05, x: -depth * 44, duration: 1, ease: 'power1.inOut', immediateRender: false }, at);
            }
          }
          tl.to({}, { duration: hold / step }); // brief pause on the last card before the section releases
          paintDims(0);
        }, this);
        setCurrent(0);

        // Keep the pin in the right place when anything on the page changes height
        // (pinned sections above growing once their animations load, fonts, images, drawers).
        let t;
        const refresh = () => { if (this.abort.signal.aborted) return; clearTimeout(t); t = setTimeout(() => ST.refresh(), 150); };
        if ('ResizeObserver' in window) {
          let lastH = document.documentElement.scrollHeight;
          this.ro = new ResizeObserver(() => {
            const h = document.documentElement.scrollHeight;
            if (Math.abs(h - lastH) > 2) { lastH = h; refresh(); }
          });
          this.ro.observe(document.body);
        }
        this.querySelectorAll('img').forEach(img => { if (!img.complete) img.addEventListener('load', refresh, { once: true, signal: this.abort.signal }); });
        document.addEventListener('calabasa:intro-complete', refresh, { signal: this.abort.signal });
        window.addEventListener('load', refresh, { once: true, signal: this.abort.signal });
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
        requestAnimationFrame(() => ST.refresh());
      }).catch(() => this.teardown());
    }
    teardown() {
      if (this.ro) { this.ro.disconnect(); this.ro = null; }
      if (this.ctx) { this.ctx.revert(); this.ctx = null; }
      this.st = null;
      this.classList.remove('is-enhanced');
      const deck = this.querySelector('[data-cc-deck]'); if (deck) deck.style.height = '';
      this.querySelectorAll('[data-cc-dim]').forEach(d => { d.style.opacity = ''; });
      this.querySelectorAll('[data-cc-card]').forEach(c => { c.inert = false; c.removeAttribute('aria-hidden'); });
    }
    disconnectedCallback() {
      this.abort && this.abort.abort();
      if (this.rowIO) { this.rowIO.disconnect(); this.rowIO = null; }
      this.teardown(); document.documentElement.classList.remove('cc-lock'); this.ready = false;
    }
  }
  customElements.define('calabasa-cocktails', CalabasaCocktails);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calabasa-community"] && !Shopify.designMode) return;
  try {
    
/* Section 5 — Community: scroll reveal, bring the form into view after submitting, preview stub. */
(() => {
  if (customElements.get('calabasa-community')) return;
  class CalabasaCommunity extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      const form = this.querySelector('[data-cm-form]');
      // After Shopify reloads the page with a result, bring the form back into view.
      if (this.querySelector('[data-cm-result]')) {
        const go = () => (this.querySelector('[data-cm-result]') || form).scrollIntoView({ block: 'center' });
        if (document.readyState === 'complete') setTimeout(go, 450); else window.addEventListener('load', () => setTimeout(go, 450), { once: true });
      }
      // Partner enquiry: open and close the form under "Follow the journey".
      const pBtn = this.querySelector('[data-cm-partner-toggle]');
      const pDrawer = this.querySelector('[data-cm-drawer]');
      if (pBtn && pDrawer) {
        pBtn.addEventListener('click', () => {
          const open = !pDrawer.classList.contains('is-open');
          pDrawer.classList.toggle('is-open', open);
          pBtn.setAttribute('aria-expanded', String(open));
          pBtn.querySelectorAll('[data-cm-partner-text]').forEach(t => { t.textContent = open ? 'Close' : pBtn.dataset.label; });
          if (open) setTimeout(() => {
            pDrawer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            const first = pDrawer.querySelector('input:not([type=hidden]),select,textarea');
            first && first.focus({ preventScroll: true });
          }, 420);
        });
      }
      // After an enquiry is sent, Shopify reloads the page: bring the result back into view.
      if (this.querySelector('[data-cm-partner-result]')) {
        const goP = () => this.querySelector('[data-cm-partner-result]').scrollIntoView({ block: 'center' });
        if (document.readyState === 'complete') setTimeout(goP, 450); else window.addEventListener('load', () => setTimeout(goP, 450), { once: true });
      }
      // Preview only: show the success state without posting anywhere.
      if (this.dataset.preview === 'true' && form) {
        form.addEventListener('submit', e => {
          e.preventDefault();
          if (!form.checkValidity()) { form.reportValidity(); return; }
          const ok = this.querySelector('[data-cm-preview-ok]'); if (ok) ok.hidden = false;
          form.querySelector('[data-cm-fields]').hidden = true;
        });
      }
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) return;
      this.classList.add('is-armed');
      this.io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); this.io.unobserve(e.target); } }),
        { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      this.querySelectorAll('[data-cm-group]').forEach(g => this.io.observe(g));
    }
    disconnectedCallback() { this.io && this.io.disconnect(); this.ready = false; }
  }
  customElements.define('calabasa-community', CalabasaCommunity);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calabasa-our-story"] && !Shopify.designMode) return;
  try {
    
/* Our Story: fade sections in as they scroll into view. Without JS everything simply shows. */
(() => {
  const root = document.querySelector('[data-os-story]');
  if (!root || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('is-armed');
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
  }), { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  root.querySelectorAll('.os-reveal').forEach(el => io.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calabasa-palm-spirit"] && !Shopify.designMode) return;
  try {
    
/* The Story of Palm Spirit: fade sections in as they scroll into view. Without JS everything simply shows. */
(() => {
  const root = document.querySelector('[data-cal-story]');
  if (!root || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  root.classList.add('is-armed');
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
  }), { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  root.querySelectorAll('.cal-reveal').forEach(el => io.observe(el));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calabasa-press"] && !Shopify.designMode) return;
  try {
    
/* Press & Features: scroll reveal and the article carousel.
   The carousel moves by each card's real position, so a swipe or arrow always lands with a card aligned to the edge
   (on phones, exactly centred). */
(() => {
  const root = document.querySelector('[data-pr-story]');
  if (!root) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  if ('IntersectionObserver' in window && !reduce) {
    root.classList.add('is-armed');
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
    }), { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    root.querySelectorAll('.pr-reveal').forEach(el => io.observe(el));
  }

  const car = root.querySelector('[data-pr-carousel]');
  if (!car) return;
  const track = car.querySelector('[data-pr-track]');
  const cards = [...track.children];
  const prev = car.querySelector('[data-pr-prev]');
  const next = car.querySelector('[data-pr-next]');
  const dotsEl = car.querySelector('[data-pr-dots]');
  let current = 0;

  const visible = () => {
    if (cards.length < 2) return 1;
    const wrap = track.parentElement;
    const cs = getComputedStyle(wrap);
    const inner = wrap.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    const step = cards[1].offsetLeft - cards[0].offsetLeft;
    return Math.max(1, Math.floor((inner + (step - cards[0].offsetWidth) + 1) / step));
  };
  const maxIdx = () => Math.max(0, cards.length - visible());

  const buildDots = () => {
    dotsEl.innerHTML = '';
    for (let i = 0; i <= maxIdx(); i++) {
      const d = document.createElement('button');
      d.type = 'button';
      d.className = 'pr-dot';
      d.setAttribute('aria-label', 'Show article ' + (i + 1));
      d.addEventListener('click', () => goTo(i));
      dotsEl.appendChild(d);
    }
  };

  const goTo = i => {
    current = Math.max(0, Math.min(i, maxIdx()));
    const x = cards[current].offsetLeft - cards[0].offsetLeft;
    track.style.transform = 'translateX(' + (-x) + 'px)';
    prev.disabled = current === 0;
    next.disabled = current >= maxIdx();
    [...dotsEl.children].forEach((d, n) => d.classList.toggle('active', n === current));
  };

  prev.addEventListener('click', () => goTo(current - 1));
  next.addEventListener('click', () => goTo(current + 1));

  // Swipe: one card per swipe, only when the gesture is mostly sideways.
  let sx = 0, sy = 0;
  track.addEventListener('touchstart', e => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  track.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - sx;
    const dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goTo(current + (dx < 0 ? 1 : -1));
  });

  buildDots();
  goTo(0);
  let rt;
  window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => { buildDots(); goTo(current); }, 120); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["calabasa-shop"] && !Shopify.designMode) return;
  try {
    
/* Section 3 — Shop Calabasa: quantity, gallery, add to cart, Buy Now permalink, scroll reveal. */
(() => {
  if (customElements.get('calabasa-shop')) return;
  class CalabasaShop extends HTMLElement {
    connectedCallback() {
      if (this.ready) return; this.ready = true;
      this.abort = new AbortController();
      const on = (el, ev, fn) => el && el.addEventListener(ev, fn, { signal: this.abort.signal });
      const q = s => this.querySelector(s);
      const root = this.dataset.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const input = q('[data-cs-qty]'), hidden = q('[data-cs-qty-hidden]');
      const buy = q('[data-cs-buy]'), form = q('[data-cs-form]');
      const variantId = form ? form.querySelector('[name="id"]').value : '';

      // Quantity: keeps the form, the Buy Now permalink and the field in step.
      const setQty = v => {
        v = Math.max(1, Math.min(99, parseInt(v, 10) || 1));
        if (input) input.value = v;
        if (hidden) hidden.value = v;
        if (buy && variantId) buy.href = `${root}cart/${variantId}:${v}`;
      };
      on(q('[data-cs-minus]'), 'click', () => setQty((+input.value || 1) - 1));
      on(q('[data-cs-plus]'), 'click', () => setQty((+input.value || 1) + 1));
      setQty(input ? input.value : 1);

      // Image slideshow: swipe, trackpad, drag, arrows, dots and arrow keys.
      const track = q('[data-cs-track]');
      if (track) {
        const slides = [...track.children];
        const dots = [...this.querySelectorAll('[data-cs-dot]')];
        const prev = q('[data-cs-prev]'), next = q('[data-cs-next]');
        let index = 0, goal = null;
        const go = i => { i = Math.max(0, Math.min(slides.length - 1, i)); goal = i; track.scrollTo({ left: i * track.clientWidth }); };
        const step = d => go((goal ?? index) + d);
        const mark = () => {
          index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (goal === index && Math.abs(track.scrollLeft - index * track.clientWidth) < 2) goal = null;
          dots.forEach((d, k) => d.setAttribute('aria-selected', k === index ? 'true' : 'false'));
          if (prev) prev.disabled = index <= 0;
          if (next) next.disabled = index >= slides.length - 1;
        };
        let raf = 0;
        on(track, 'scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
        on(prev, 'click', () => step(-1));
        on(next, 'click', () => step(1));
        dots.forEach((d, k) => on(d, 'click', () => go(k)));
        on(track, 'keydown', e => {
          if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
        });
        // Mouse drag on desktop; touch and trackpads scroll natively.
        let startX = 0, startLeft = 0, dragging = false, moved = false;
        on(track, 'pointerdown', e => {
          if (e.pointerType !== 'mouse' || e.button !== 0 || slides.length < 2) return;
          dragging = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
          track.classList.add('is-dragging'); track.setPointerCapture(e.pointerId);
        });
        on(track, 'pointermove', e => {
          if (!dragging) return;
          const dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true;
          track.scrollLeft = startLeft - dx;
        });
        const end = e => {
          if (!dragging) return; dragging = false;
          const dx = e.clientX - startX;
          track.classList.remove('is-dragging');
          const target = Math.abs(dx) > track.clientWidth * 0.12 ? index + (dx < 0 ? 1 : -1) : Math.round(startLeft / track.clientWidth);
          requestAnimationFrame(() => go(target));
        };
        on(track, 'pointerup', end); on(track, 'pointercancel', end);
        on(track, 'click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, { capture: true });
        on(window, 'resize', () => track.scrollTo({ left: index * track.clientWidth, behavior: 'instant' }));
        mark();
      }

      // Add to cart: AJAX, then on to the cart, matching the product page.
      const status = q('[data-cs-status]');
      on(form, 'submit', e => {
        e.preventDefault();
        const btn = form.querySelector('[data-cs-add]'); const label = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding…'; if (status) status.textContent = '';
        const done = () => { btn.textContent = 'Added ✓'; btn.classList.add('is-added'); setTimeout(() => { window.location.href = `${root}cart`; }, 800); };
        if (this.dataset.preview === 'true') { done(); return; }
        fetch(`${root}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: parseInt(hidden.value, 10) || 1 })
        }).then(r => r.ok ? r.json() : r.json().then(j => Promise.reject(j)))
          .then(done)
          .catch(err => {
            btn.disabled = false; btn.textContent = label;
            if (status) status.textContent = (err && err.description) || 'Something went wrong. Please try again.';
          });
      });

      // Arriving on /#shop: earlier sections change height as their animations load,
      // so re-aim once the page has settled, and again after the intro if it ran.
      if (this.id && decodeURIComponent(location.hash.slice(1)) === this.id) {
        const go = () => this.scrollIntoView({ block: 'start' });
        const settle = () => setTimeout(go, 450);
        if (document.readyState === 'complete') settle(); else window.addEventListener('load', settle, { once: true, signal: this.abort.signal });
        document.addEventListener('calabasa:intro-complete', () => setTimeout(go, 60), { once: true, signal: this.abort.signal });
      }

      // Scroll reveal, staggered per group. Skipped for reduced motion and in the theme editor.
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || (window.Shopify && window.Shopify.designMode) || !('IntersectionObserver' in window)) return;
      this.classList.add('is-armed');
      const io = new IntersectionObserver(entries => entries.forEach(en => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      }), { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      this.querySelectorAll('[data-cs-group]').forEach(g => io.observe(g));
      this.io = io;
    }
    disconnectedCallback() { this.abort && this.abort.abort(); this.io && this.io.disconnect(); this.ready = false; }
  }
  customElements.define('calabasa-shop', CalabasaShop);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
